import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  he: {
    translation: {
      menu_title: "תפריט",
      table_view: "טבלה",
      cards_view: "כרטיסים",
      add_to_cart: "הוסף לסל",
      israel_kitchen:"המטבח של ישראל",
      gallery:"גלריה",
      about_me:"קצת עליי",
      events:"אירועים",
      about_me_text:`אני ישראל, בן למשפחה מרוקאית שגדל על סירים מלאים בריחות ותבלינים של בית. הבישול בשבילי הוא דרך לבטא אהבה, כל תבשיל מספר סיפור, כל טעם מזכיר רגע משפחתי חם. אני מבשל מגיל צעיר, באהבה גדולה וביד נדיבה, ומאמין שאוכל טוב הוא כזה שמרגישים בו את הנשמה. האוכל שלי הוא אוכל ביתי, מנחם, עם טעמים אמיתיים של בית, כזה שמזכיר את המטבח של אמא, עם נגיעה אישית שלי.`,
      one_handred_and_fifty_gram:"150 גרם",
      two_handred_gram:"200 גרם",
      three_handred_gram:"300 גרם",
      add_to_count_msg:"היי , הפריט כבר בסל הכמות עודכנה עד עכשיו : ",
      add_to_cart_msg:"היי המוצר התווסף לסל עד עכשיו :",
      select_category:"בחר קטגוריה",
      name:"שם המנה",
      name_for_choose:"name",
      quantity:"כמות",
      quantity_f_s:"Amount",
      price:"מחיר",
      sale:"",
      sale2:"מבצ",
      total:`סה"כ להזמנה`,
      delivery_pickup_title: "משלוחים ואיסוף",
      delivery_extra: "משלוחים בתוספת תשלום",
    self_pickup: "איסוף עצמי מריברדייל",
    orders_until: "הזמנות מתקבלות עד יום חמישי בשעה 12:00 בצהריים",
    contact_title: "יצירת קשר",
    add_to_contacts: "להוספה לאנשי קשר לחצו כאן!",
    order_phone: "טלפון להזמנות",
    find_us_facebook: "חפשו אותנו בפייסבוק",

    footer_rights: " המטבח של ישראל",
    cart_cleared: "העגלה אופסה",
    item_removed: "הפריט הוסר מהעגלה",
    view_cart: "הצג סל",
    shopping_cart: "סל הקניות",
    minimize: "מיזעור",
    your_cart: "סל הקניות שלך",
    cart_empty: "הסל ריק",
    reset_cart: "איפוס סל",
    checkout_here: "לסיום לחץ כאן",
    dell:"מחק",
    total_f_d:`סה"כ למוצר`,
     new_order: "הזמנה חדשה",
    cart_title: "סל קניות",
    total_to_pay: "סה\"כ לתשלום",

    full_name: "שם מלא",
    family_name: "שם ושם משפחה",
    phone_order: "טלפון המזמין",
    notes: "הערות",
    write_notes_here: "אם יש הערות כתבו כאן",

    delivery_or_pickup: "איסוף או משלוח",
    pickup: "איסוף עצמי",
    delivery: "משלוח",
    address:"כתובת למשלוח", 
    address_details: "רחוב, מספר דירה, קומה",  
    pay_with_venmo: "תשלום דרך ונמו",
    send_order_whatsapp: "שליחת הזמנה בוואטסאפ",
    price_f_u:"מחיר ליחידה",
    delivery_cost:`משלוחים למנהטן ביום שישי בשעות הבוקר - עלות משלוח היא 10$ להזמנה מעל 150$, ו-20$ להזמנה מתחת לסכום זה.`
      // וכו' – כל המילים שיש לך באתר
    },
  },
  en: {
    translation: {
        menu_title: "Menu",
        table_view: "Table",
        cards_view: "Cards",
        add_to_cart: "Add to cart",
        israel_kitchen:"Israel's Kitchen",
        gallery:"Gallery",
        about_me:"About Me",
        events:"Events",
        about_me_text:`I am Israel, born into a Moroccan family and raised on pots filled with familiar aromas and warm home-cooked spices. For me, cooking is a way to express love , every dish tells a story, and every flavor brings back a heartfelt family moment. I’ve been cooking since a young age, with great passion and a generous hand, and I believe that good food is food you can feel in your soul. My cooking is homemade, comforting, with authentic flavors that remind you of the dishes from your mother’s kitchen, infused with my own personal touch.`,
        one_handred_and_fifty_gram:"5.5 Oz",
        two_handred_gram:"7 Oz",
        three_handred_gram:"10.5 Oz",
        add_to_count_msg:"This item is already in your cart. The quantity has been updated to:",
        add_to_cart_msg:"Successfully added to cart. The quantity has been updated to:",
        select_category:"Select Category",
        name:"Dish name",
        name_for_choose:"Dish",
        quantity:"Quantity",
        quantity_f_s:"quantity",
        price:"Price",
        sale:``,
        total:"Total in order",
        delivery_pickup_title: "Delivery & Pickup",
    delivery_extra: "Delivery available for an additional fee",
    self_pickup: "Self pickup in Riverdale",
    orders_until: "Orders accepted until Thursday at 12:00 PM",
    contact_title: "Contact Us",
    add_to_contacts: "Click here to add to contacts!",
    order_phone: "Phone for orders",
    find_us_facebook: "Find us on Facebook",
    footer_rights: " Israel Kitchen ",
    cart_cleared: "The cart has been cleared",
    item_removed: "The item has been removed from the cart",
    view_cart: "View Cart",
    shopping_cart: "Shopping Cart",
    minimize: "Minimize",
    your_cart: "Your Cart",
    cart_empty: "Your cart is empty",
    reset_cart: "Reset Cart",
    checkout_here: "Click here to checkout",
    dell:"Dellete",
    total_f_d:"Item total",
    new_order: "New Order",
    cart_title: "Shopping Cart",
    total_to_pay: "Total to Pay",

    full_name: "Full Name",
    family_name: "Name and Family Name",
    phone_order: "Customer Phone",
    notes: "Notes",
    write_notes_here: "Write any notes here",

    delivery_or_pickup: "Pickup or Delivery",
    pickup: "Pickup",
    delivery: "Delivery",
    address: "Shipping Address",
    address_details: "Street, Apartment Number, Floor",
    pay_with_venmo: "Pay with Venmo",
    send_order_whatsapp: "Send Order via WhatsApp",

    item_total: "Item Total",
    price_f_u: "Unit Price",
    delivery_cost:`Deliveries to Manhattan on Friday mornings – the delivery cost is $10 for orders over $150, and $20 for orders below that amount.`
      // אותו דבר באנגלית
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "he",            // שפת ברירת מחדל
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
